import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import Dropdown from '../../../../assets/icons/arrow_down.svg';
import { useAuth } from 'context/AuthContext';
import { ehMesmoContexto, razaoSocialDiferenteDoNomeFantasia, rotuloDocumentoDoCliente } from 'utils/contextos';

const LARGURA_MAXIMA_MOBILE = 768;

const DetalhesContexto = ({ contexto }) => (
  <div className="header-signature-detalhes">
    <strong>{contexto.clienteNomeFantasia}</strong>
    {razaoSocialDiferenteDoNomeFantasia(contexto) && <small>{contexto.clienteRazaoSocial}</small>}
    {contexto.clienteCnpj && <small>{rotuloDocumentoDoCliente(contexto.clienteCnpj)} {contexto.clienteCnpj}</small>}
    {contexto.tenantNomeExibicao && <span>{contexto.tenantNomeExibicao}</span>}
  </div>
);

const Signature = () => {
  const {contexto, contextos, loading, AlterarContexto} = useAuth()
  const [outrosContextos, setOutrosContextos] = useState([]);
  const [showSignatureList, setShowSignatureList] = useState(false);

  useEffect(()=>{
    if(contextos == null || contexto == null) return;
    setOutrosContextos(contextos.filter(outroContexto => !ehMesmoContexto(outroContexto, contexto)));
  },[contextos, contexto])

  const onClickChangeSignatureShow = () => {
    if (window.innerWidth < LARGURA_MAXIMA_MOBILE) {
      setShowSignatureList(!showSignatureList)
    }
  }
  return (
    <div
      className="header-signature"
      onClick={onClickChangeSignatureShow}
      onMouseEnter={() => setShowSignatureList(true)}
      onMouseLeave={() => setShowSignatureList(false)}
    >
      <strong className="header-signature-cliente">{contexto?.clienteNomeFantasia}</strong>
      {contexto?.tenantNomeExibicao && <small className="header-signature-tenant">{contexto.tenantNomeExibicao}</small>}

      <img className="dropdown" src={Dropdown} alt="Dropdown" />

      {
        !!showSignatureList && contexto && (
          <div className="header-signature-list">
            <h5>Contexto atual</h5>
            <DetalhesContexto contexto={contexto} />

            {outrosContextos.length > 0 && <h5>Alterar contexto</h5>}
            {
              loading  ? (
                <div className="is_loading">
                  <svg className="spinner" width="32px" height="32px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle className="path" fill="none" strokeWidth="3" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              ) : (
                <div className="header-signature-items">
                  {outrosContextos.map(outroContexto => (
                    <Tooltip
                      key={`${outroContexto.clienteId}_${outroContexto.tenantId}`}
                      title={<DetalhesContexto contexto={outroContexto} />}
                      placement="right"
                      mouseEnterDelay={0.5}
                    >
                      <div
                        onClick={async () => AlterarContexto(outroContexto)}
                        className="header-signature-item"
                      >
                        <span className="header-signature-cliente">{outroContexto.clienteNomeFantasia}</span>
                        {outroContexto.tenantNomeExibicao && <small className="header-signature-tenant">{outroContexto.tenantNomeExibicao}</small>}
                      </div>
                    </Tooltip>
                  ))}
                </div>
              )
            }
          </div>
        )
      }
    </div>
  )
}

export default Signature
